export const Constants = {
    CLIENT: "client",
    ADMIN: "admin",
    GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
}

export const PortalVersions = {
    ADMIN: "1.6.4",
    CLIENT: "1.0.3",
}

export const UserRoles = {
    ADMIN: "admin",
    REGIONAL_MANAGER: "regional_manager",
}

export const getUserRoles = userOrRole => {
    if (!userOrRole) return [];
    if (typeof userOrRole === "string") return [userOrRole];
    return [
        userOrRole?.role,
        ...(Array.isArray(userOrRole?.roles) ? userOrRole.roles : []),
    ].filter(Boolean).map(role => role.toString().trim());
};

export const hasUserRole = (userOrRole, role) => getUserRoles(userOrRole).includes(role);

export const isAdminRole = userOrRole => hasUserRole(userOrRole, UserRoles.ADMIN);

export const isRegionalManagerRole = userOrRole => getUserRoles(userOrRole).some(role => [
    UserRoles.REGIONAL_MANAGER,
    "regionalManager",
    "regional-manager",
].includes(role));

export const getRegionalOriginIds = user => {
    const originIds = Array.isArray(user?.originIds) ? user.originIds : [];
    return [...new Set([
        ...originIds,
        user?.originId,
        user?.provinceId,
    ].filter(Boolean).map(value => value.toString()))];
};

export const TripAssignStatuses = {
    REQUESTED_ALL : 0,
    ACCEPTED_BY: 1,
    REASSIGNED_TO: 2
}

export const ClientStatus = [
    {
        label: "In Active",
        id: 0
    },
    {
        label: "Active",
        id: 1
    }
]



export const TripType = {
    OneWay: 0,
    Return: 1,
}
export const TripStatus = {
    TripStarted: 7,
    PreInspection: 6,
    PostInspection: 8,
    Cancelled: 4,
    Pending: 1,
    DriverAccepted: 3,
    Completed: 5,
    Unassigned: 0
}


export const MessageType = {
    TripOrderUpdated: 3
}

export const TRIP_STATUSES = [
    "Pending", //0 
    "Sent to", //1
    "Pending",//2
    "Accepted by",//3
    "Cancelled",//4
    "Completed",//5
    "Pre inspection",//6
    "On route",//7
    "Post inspection",//8
]
export const FILTER_TRIP_STATUSES = [
    {
        label: "Pending",
        value: 1
    },
    {
        label: "On Route",
        value: 7
    },
    {
        label: "Completed",
        value: 5
    },
    {
        label: "Cancelled",
        value: 4
    },
    
]


export const isAdmin = process.env.REACT_APP_MODE === Constants.ADMIN;
